import { types } from 'mobx-state-tree';
import { BaseEntity } from './BaseEntity';
import { Role } from './Role';

export const User = types.compose(
  BaseEntity,
  types.model('User', {
    userId: types.identifierNumber,
    firstName: types.string,
    lastName: types.string,
    userName: types.string,
    password: types.maybe(types.string),
    languageCode: types.maybe(types.string),
    email: types.string,
    isActive: types.boolean,
    secretaryId: types.maybe(types.number),
    pharmacyId: types.maybe(types.number),
    secretariatUserId: types.maybe(types.number),
    pharmacyUserId: types.maybe(types.number),
    roles: types.optional(types.array(Role), []),
  }),
);
